import type { Template } from "@/types";

export const LA_07_H6_V1: Template[] = [
    {
        id: "la-07-h6v1-01",
        name: "LA 01 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h6_v1_01.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 86, y: 69, width: 260, height: 169, rotation: 0, imageRotation: 0 },
            { id: "2", x: 86, y: 245, width: 260, height: 169, rotation: 0, imageRotation: 0 },
            { id: "3", x: 354, y: 69, width: 237, height: 345, rotation: 0, imageRotation: 0 },
            { id: "4", x: 750, y: 69, width: 260, height: 169, rotation: 0, imageRotation: 0 },
            { id: "5", x: 750, y: 245, width: 260, height: 169, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 69, width: 259, height: 169, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1018, y: 245, width: 259, height: 169, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h6v1-02",
        name: "LA 02 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h6_v1_02.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 122, y: 40, width: 432, height: 268, rotation: 0, imageRotation: 0 },
            { id: "2", x: 122, y: 315, width: 213, height: 129, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 315, width: 212, height: 129, rotation: 0, imageRotation: 0 },
            { id: "4", x: 759, y: 40, width: 200, height: 130, rotation: 0, imageRotation: 0 },
            { id: "5", x: 759, y: 177, width: 200, height: 130, rotation: 0, imageRotation: 0 },
            { id: "6", x: 759, y: 314, width: 200, height: 130, rotation: 0, imageRotation: 0 },
            { id: "7", x: 966, y: 40, width: 303, height: 404, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h6v1-03",
        name: "LA 03 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h6_v1_03.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 107, y: 52, width: 463, height: 268, rotation: 0, imageRotation: 0 },    
            { id: "2", x: 107, y: 328, width: 149, height: 103, rotation: 0, imageRotation: 0 },
            { id: "3", x: 264, y: 328, width: 149, height: 103, rotation: 0, imageRotation: 0 },
            { id: "4", x: 421, y: 328, width: 149, height: 103, rotation: 0, imageRotation: 0 },
            { id: "5", x: 827, y: 52, width: 348, height: 224, rotation: 0, imageRotation: 0 },
            { id: "6", x: 827, y: 284, width: 229, height: 147, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1064, y: 284, width: 111, height: 147, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h6v1-04",
        name: "LA 04 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h6_v1_04.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 132, y: 46, width: 203, height: 127, rotation: 0, imageRotation: 0 },
            { id: "2", x: 132, y: 180, width: 203, height: 126, rotation: 0, imageRotation: 0 },
            { id: "3", x: 132, y: 312, width: 203, height: 126, rotation: 0, imageRotation: 0 },
            { id: "4", x: 342, y: 46, width: 203, height: 127, rotation: 0, imageRotation: 0 },
            { id: "5", x: 342, y: 180, width: 203, height: 126, rotation: 0, imageRotation: 0 },
            { id: "6", x: 342, y: 312, width: 203, height: 126, rotation: 0, imageRotation: 0 },
            { id: "7", x: 873, y: 46, width: 282, height: 392, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h6v1-05",
        name: "LA 05 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h6_v1_05.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 195, y: 36, width: 286, height: 410, rotation: 0, imageRotation: 0 },
            { id: "2", x: 762, y: 36, width: 330, height: 202, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1099, y: 36, width: 158, height: 98, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1099, y: 141, width: 158, height: 97, rotation: 0, imageRotation: 0 },
            { id: "5", x: 762, y: 245, width: 158, height: 98, rotation: 0, imageRotation: 0 },
            { id: "6", x: 762, y: 350, width: 158, height: 96, rotation: 0, imageRotation: 0 },
            { id: "7", x: 928, y: 245, width: 330, height: 201, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h6v1-06",
        name: "LA 06 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h6_v1_06.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 100, y: 47, width: 476, height: 286, rotation: 0, imageRotation: 0 },
            { id: "2", x: 100, y: 340, width: 154, height: 97, rotation: 0, imageRotation: 0 },
            { id: "3", x: 261, y: 340, width: 154, height: 97, rotation: 0, imageRotation: 0 },
            { id: "4", x: 422, y: 340, width: 154, height: 97, rotation: 0, imageRotation: 0 },
            { id: "5", x: 742, y: 47, width: 258, height: 391, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1008, y: 47, width: 278, height: 192, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1008, y: 246, width: 278, height: 191, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h6v1-07",
        name: "LA 07 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h6_v1_07.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 74, y: 36, width: 292, height: 412, rotation: 0, imageRotation: 0 },
            { id: "2", x: 374, y: 36, width: 217, height: 133, rotation: 0, imageRotation: 0 },
            { id: "3", x: 374, y: 176, width: 217, height: 133, rotation: 0, imageRotation: 0 },
            { id: "4", x: 374, y: 316, width: 217, height: 132, rotation: 0, imageRotation: 0 },
            { id: "5", x: 768, y: 316, width: 241, height: 132, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1017, y: 316, width: 241, height: 132, rotation: 0, imageRotation: 0 },
            { id: "7", x: 768, y: 36, width: 490, height: 273, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h6v1-08",
        name: "LA 08 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h6_v1_08.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 74, y: 36, width: 217, height: 133, rotation: 0, imageRotation: 0 },
            { id: "2", x: 74, y: 176, width: 217, height: 133, rotation: 0, imageRotation: 0 },
            { id: "3", x: 74, y: 316, width: 217, height: 132, rotation: 0, imageRotation: 0 },
            { id: "4", x: 299, y: 36, width: 292, height: 412, rotation: 0, imageRotation: 0 },
            { id: "5", x: 899, y: 36, width: 230, height: 133, rotation: 0, imageRotation: 0 },
            { id: "6", x: 899, y: 176, width: 230, height: 133, rotation: 0, imageRotation: 0 },
            { id: "7", x: 899, y: 316, width: 230, height: 133, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h6v1-09",
        name: "LA 09 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h6_v1_09.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 58, y: 35, width: 304, height: 203, rotation: 0, imageRotation: 0 },
            { id: "2", x: 58, y: 245, width: 304, height: 202, rotation: 0, imageRotation: 0 },
            { id: "3", x: 369, y: 35, width: 304, height: 203, rotation: 0, imageRotation: 0 },
            { id: "4", x: 369, y: 245, width: 304, height: 202, rotation: 0, imageRotation: 0 },
            { id: "5", x: 680, y: 35, width: 303, height: 412, rotation: 0, imageRotation: 0 },
            { id: "6", x: 990, y: 35, width: 304, height: 203, rotation: 0, imageRotation: 0 },
            { id: "7", x: 990, y: 245, width: 304, height: 202, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h6v1-10",
        name: "LA 10 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h6_v1_10.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 58, y: 35, width: 304, height: 203, rotation: 0, imageRotation: 0 },
            { id: "2", x: 58, y: 245, width: 304, height: 202, rotation: 0, imageRotation: 0 },
            { id: "3", x: 369, y: 35, width: 304, height: 203, rotation: 0, imageRotation: 0 },
            { id: "4", x: 369, y: 245, width: 304, height: 202, rotation: 0, imageRotation: 0 },
            { id: "5", x: 680, y: 35, width: 304, height: 203, rotation: 0, imageRotation: 0 },
            { id: "6", x: 680, y: 245, width: 304, height: 202, rotation: 0, imageRotation: 0 },
            { id: "7", x: 991, y: 35, width: 303, height: 412, rotation: 0, imageRotation: 0 }
        ],
    }
];